// src/utils/helpers.ts

import { HOLE_IN_ONE_CLAIM_WINDOW_HOURS } from "./config";

/**
 * Validates an email address format.
 * @param email - The email string to validate.
 * @returns True if the email format is valid, false otherwise.
 */
export function validateEmail(email: string): boolean {
	// Basic regex, consider a more robust one for production
	const re = /\S+@\S+\.\S+/;
	return re.test(email);
}
